// The catalogue titles for the Date Operations are literally "Date +Xd" and
// "Date +Xm" (data/storydoc-variables.ts) — `X` is a PLACEHOLDER for whatever
// amount the author typed into the pill, not part of the name. This strips it
// so the real offsets can take its place.
const PLACEHOLDER_OFFSET_RE = /\s*[+-]X[dmy]\b/gi;

/**
 * Label for a date variable's share-dialog row, carrying the offsets the
 * story actually applies to it: `Date +7d`, or `Date +7d, +1m` when the deck
 * uses the same base date with several offsets (there is still ONE row — the
 * sender fills the base date once and every pill derives from it).
 *
 * Returns `title` untouched when the story uses the variable bare, so a
 * variable nobody offset reads exactly as it did before.
 */
export const dateOffsetLabel = (
  title: string,
  dateOffsets?: readonly string[],
): string => {
  if (!dateOffsets?.length) return title;
  const base = title.replace(PLACEHOLDER_OFFSET_RE, "").trim();
  return `${base || title} ${dateOffsets.join(", ")}`;
};
